module.exports = __webpack_public_path__ + "static/img/02-Classic-T.409bb6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/02-Classic-T.jpg
// module id = erkX
// module chunks = 12